import { ContactPerson } from '../../../../../types/contactPerson'

interface UpdateAndReassignPrimaryContactProps {
  contacts: ContactPerson[]
  currentPrimaryContactIndex: number
  editedIndex: number
  email?: string
  firstName?: string
  lastName?: string
  newPrimaryContactData: ContactPerson
}

// TODO: extract this function into a reusable utility
export const updateAndReassignPrimaryContact = ({
  contacts,
  currentPrimaryContactIndex,
  editedIndex,
  email,
  firstName,
  lastName,
  newPrimaryContactData,
}: UpdateAndReassignPrimaryContactProps): ContactPerson[] => {
  const updatedContacts = [...contacts]

  updatedContacts[editedIndex] = {
    ...updatedContacts[editedIndex],
    email,
    firstName,
    lastName,
  }

  updatedContacts[currentPrimaryContactIndex] = {
    ...updatedContacts[currentPrimaryContactIndex],
    ...newPrimaryContactData,
  }

  return updatedContacts
}
